import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import UFOSegment from "@atlassian/wac-ufo-segment";

import { useLocalizedHref } from "@/libraries/web-framework";
import { ADG4CtaWithPolygonBackground } from "@/patterns/adg4/cta-with-polygon-background/cta-with-polygon-background";

export const CtaSection = () => {
    const intl = useIntl();
    return (
        <UFOSegment name="enterprise-page-cta">
            <section css={ctaSectionContainerStyle}>
                <ADG4CtaWithPolygonBackground
                    header={intl.formatMessage({
                        id: "EnterpriseLandingPage.CallToActionSection.header",
                        defaultMessage:
                            "Build your system of work with Atlassian"
                    })}
                    ctaText={intl.formatMessage({
                        id: "EnterpriseLandingPage.CallToActionSection.buttonText",
                        defaultMessage: "Contact sales"
                    })}
                    ctaUrl={useLocalizedHref(
                        "/enterprise/contact?formType=product-features"
                    )}
                    ctaLabel="Contact sales"
                    productKey="enterprise"
                />
            </section>
        </UFOSegment>
    );
};

const ctaSectionContainerStyle = css({
    backgroundImage: "linear-gradient(to bottom, #f0f2f4 50%, transparent 50%)",
    padding: "40px 0",
    section: {
        margin: "0 auto"
    }
});
